import React, { Component } from 'react';
import { Checkbox } from 'semantic-ui-react';
import ReactTable from 'react-table';

import { MealEquivalentSetupEnum as Fields } from 'Common/FieldEnum';
import { caseInsensitiveFilter } from 'Common/GridHelper';

class EquivalentSiteGrid extends Component {
  reactTableRef = React.createRef();
  state = { filtered: false, filteredData: [], filterCheckAll: false };

  handleCheckAllChange = (e, data) => {
    const { filtered, filteredData } = this.state;
    const { checkAll, checkItem } = this.props;

    if (filtered) {
      this.setState({ filterCheckAll: data.checked });
      filteredData.forEach(element => {
        checkItem(data.checked, element);
      });
    }
    if (!filtered) {
      checkAll(data.checked);
    }
  };

  handleCheckedItem = (checkedValue, row) => {
    this.props.checkItem(checkedValue, row);
  };

  getColumns = () => {
    return [
      {
        Header: (
          <div style={{ textAlign: 'center' }}>
            <div>Selected</div>
            <Checkbox
              onChange={this.handleCheckAllChange}
              checked={this.props.isAllChecked || this.state.filterCheckAll}
            />
          </div>
        ),

        Cell: ({ original }) => {
          return (
            <div style={{ textAlign: 'center' }}>
              <Checkbox
                checked={original.Selected}
                onChange={(e, data) =>
                  this.handleCheckedItem(!original.Selected, original)
                }
              />
            </div>
          );
        },
        filterable: false,
        sortable: false,
        maxWidth: 75,
      },

      {
        Header: 'Site Id',
        accessor: Fields.SiteId,
        filterable: true,
      },
      {
        Header: 'Description',
        accessor: Fields.SiteDescription,
        filterable: true,
      },
      {
        Header: 'Site Group',
        accessor: Fields.SiteGroupDescription,
        filterable: true,
      },
      {
        Header: 'Breakfast',
        className: 'right-align',
        accessor: Fields.BreakfastToLunch,
        filterable: true,
      },
      {
        Header: 'Snack',
        className: 'right-align',
        accessor: Fields.SnackToLunch,
        filterable: true,
      },
      {
        Header: 'Supplemental',
        className: 'right-align',
        accessor: Fields.SupplementalToLunch,
        filterable: true,
      },
    ];
  };

  handleFilter = filtered => {
    if (!filtered.length) {
      this.setState({
        filtered: false,
        filteredData: [],
        filterCheckAll: false,
      });
    }
    if (filtered.length > 0) {
      const filteredData = this.reactTableRef.current.state.sortedData;

      this.setState({ filtered: true, filteredData });
    }
  };

  render() {
    return (
      <ReactTable
        loading={this.props.loading}
        defaultFilterMethod={caseInsensitiveFilter}
        onFilteredChange={this.handleFilter}
        data={this.props.gridData || []}
        columns={this.getColumns()}
        defaultPageSize={10}
        ref={this.reactTableRef}
      />
    );
  }
}

export { EquivalentSiteGrid };



// WEBPACK FOOTER //
// ./src/pages/mealequivalentsetup/components/EquivalentSiteGrid.js